export default "__VITE_ASSET__dClArOu4__"